const Bug = ({ width, height, className, color = '#666666', ...rest }) => {
  return (
    <svg
      width={width}
      height={height}
      className={className}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      role="img"
      aria-hidden="true"
      {...rest}
    >
      <path
        d="M14.3044 8.75H11.153"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M4.85144 8.75H1.7"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M11.1531 7.17434V10.3252C11.1531 10.5038 11.1378 10.6823 11.106 10.8504C10.859 12.3421 9.56233 13.4761 8.00221 13.4761C6.44209 13.4761 5.14537 12.3421 4.8984 10.8504C4.86719 10.6823 4.85131 10.5038 4.85131 10.3252V7.17434C4.85131 6.99582 4.86719 6.8173 4.8984 6.64919C5.14537 5.15752 6.44209 4.02344 8.00221 4.02344C8.87399 4.02344 9.66144 4.375 10.2293 4.94779C10.6855 5.39901 11.0014 5.98768 11.106 6.64919C11.1378 6.8173 11.1531 6.99582 11.1531 7.17434Z"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M2.2253 3.49609V3.94075C2.2253 4.64441 2.50129 5.32015 2.99358 5.82285L3.01001 5.83983C3.51545 6.35622 4.20816 6.64699 4.931 6.64699H11.0893C11.8028 6.64699 12.4868 6.36388 12.9917 5.85899C13.496 5.3552 13.7797 4.6707 13.7797 3.95772V3.49609"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M11.1059 10.8477H11.1207C11.814 10.8477 12.4787 11.1226 12.9689 11.6127L13.0132 11.6576C13.5039 12.1477 13.7793 12.8125 13.7793 13.5057V13.9986"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M2.22548 13.9986V13.5221C2.22548 12.8376 2.4938 12.1811 2.97241 11.6926L3.03319 11.6313C3.52439 11.1302 4.19684 10.8477 4.89887 10.8477"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M8.00239 6.64844V13.4754"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M10.1026 4.82852V3.49456C10.1026 2.81571 9.67329 2.23718 9.07136 2.01562"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
      <path
        d="M5.90155 4.83083V3.49687C5.90155 2.79882 6.35547 2.20685 6.98426 2"
        stroke={color}
        stroke-width="1.25"
        stroke-linecap="round"
      ></path>
    </svg>
  );
};

export default Bug;
